var _ellipse, _path, _path2, _path3, _polygon, _path4, _path5, _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlibabaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.083,
    cy: 12.5,
    fill: "#f4511e",
    rx: 3.917,
    ry: 3.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f4511e",
    d: "M7.146,17.5c0,0,2.324,1.584,4.229,3.333c1.823,1.674,3.083,3.083,2.292,6.542 c-1.533,6.699-4.896,12.417-4.896,12.417l-5.875-3.229c1.34-1.193,3.915-3.556,5.792-5.75c2.122-2.481,3.356-4.828,0.979-6.542 c-3.465-2.498-5.104-3.062-5.104-3.062L7.146,17.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#f4511e",
    d: "M18.042,8.083c0,0-2.479,7.729-5.979,10.885c1.563,1,3.406,2.125,3.406,2.125 S21.906,13.573,23,10.042C21.25,9.542,18.042,8.083,18.042,8.083z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#f4511e",
    d: "M18.697,13.515c0,0,23.303-7.39,25.656,3.529c0.727,3.81,0.885,12.774,0.253,16.678S42,43,30,40 c0.077-0.582,0.103-1.311,0.514-2.842c8.468,2.655,8.72-3.154,8.72-3.154V18.013c-0.032-5.216-5.15-6.871-21.39,0L18.697,13.515z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#f4511e",
    points: "35.641,28.359 32.266,29.359 34.375,36.969 38.469,35.188"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#f4511e",
    d: "M21.344,14.813c0,0-0.719,3.531-4.656,8c1.125,1,2.125,1.969,2.125,1.969s5.094-4.313,7.344-8.5 C24.969,15.938,21.344,14.813,21.344,14.813z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#f4511e",
    d: "M15.719,29l5.26,0.042c0,0-1.573,4.958,3.146,4.521s5.438,0.063,8.844-2.438 c0.625,1.469,0.813,2.469,0.813,2.469S30.063,36.917,21,36.917C13.406,36.917,15.719,29,15.719,29z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 3,
    x: 21,
    y: 19,
    fill: "#f4511e"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 14,
    x: 24,
    y: 20,
    fill: "#f4511e"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 3,
    x: 16,
    y: 25,
    fill: "#f4511e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlibabaIcon);
export default __webpack_public_path__ + "static/media/alibabaIcon.88464c91c79faf7dd0365d5bb779abe1.svg";
export { ForwardRef as ReactComponent };